module.exports = __webpack_public_path__ + "static/media/castle-phone-tablet.e79c7d2d.png";